import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ONE_SURVEY } from './constants';
import {
  OneSurveySuccess,
  OneSurveyError,
  OneSurveyDataActionTypes,
  IOneSurveyState,
} from './types';

const initialState: IOneSurveyState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (draft = initialState, action: OneSurveyDataActionTypes): IOneSurveyState => {
    switch (action.type) {
      case ONE_SURVEY + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ONE_SURVEY + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as OneSurveySuccess).payload;
        break;
      }
      case ONE_SURVEY + FAILURE: {
        draft.status = rejected;
        draft.error = (action as OneSurveyError).error;
        break;
      }
      case ONE_SURVEY + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
